<template>
  <div class="home">
    <h2>WL Configs</h2>
    <b-button
      @click="raisePopup({ target: $event.target, isActive: true })"
      variant="primary"
      >Add new</b-button
    >
    <b-modal
      id="wlConfigModal"
      v-bind:title="this.isEdit ? 'Edit config' : 'New config'"
      @ok="wlConfigFormSubmit"
      :ok-disabled="!form.whitelabelId || !form.config"
    >
      <span class="edit-warning" v-if="this.isEdit">
        This action will overwrite config for
        {{ form.whitelabelName }}
      </span>
      <b-form>
        <b-form-group
          id="newWlConfigInputGroup1"
          label="Whitelabel ID:"
          label-for="newWlConfigInputGroup1"
        >
          <b-form-input
            id="newWlConfigInput1"
            type="number"
            v-model="form.whitelabelId"
            placeholder="Enter Whitelabel ID"
            v-bind:disabled="this.isEdit"
          />
        </b-form-group>
        <b-form-group
          id="newWlConfigInputGroup2"
          label="Config:"
          label-for="newWlConfigFile1"
        >
          <b-form-file
            id="newWlConfigFile1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="form.config"
          ></b-form-file>
        </b-form-group>
        <b-form-checkbox v-model="form.isActive" name="check-button" switch
          >IsActive</b-form-checkbox
        >
      </b-form>
    </b-modal>
    <b-container fluid>
      <b-table
        show-empty
        small
        striped
        :items="this.$store.state.wlConfig.rows"
        :fields="fields"
        stacked="md"
        class="localisation-table"
      >
        <template v-slot:cell(whitelabelId)="row">
          {{ row.item.whitelabelId }} ({{ row.item.whitelabel.name }})
        </template>
        <template v-slot:cell(config)="row">
          <div>
            <vue-json-pretty
              :deep="0"
              :data="row.item.config"
            ></vue-json-pretty>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            variant="success"
            class="m-1 ml-3"
            @click="download(row.item.config, row.item.whitelabel.name)"
            >⇩</b-button
          >
          <b-button
            size="sm"
            class="m-1 ml-3"
            variant="warning"
            @click="
              raisePopup({
                isEdit: true,
                whitelabelId: row.item.whitelabelId,
                whitelabelName: row.item.whitelabel.name,
                isActive: row.item.isActive,
                target: $event.target
              })
            "
            >✎</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="deleteWlConfig(row.item.id)"
            >X</b-button
          >
          <b-form-checkbox
            v-model="row.item.isActive"
            name="check-button"
            switch
            class="active-switch"
            size="lg"
            @change="changeIsActive(row.item.id)"
          ></b-form-checkbox>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
import VueJsonPretty from 'vue-json-pretty';

export default {
  name: 'WLConfigs',
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isEdit: false,
      form: {
        whitelabelId: null,
        config: null,
        whitelabelName: null,
        isActive: false
      }
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'whitelabelId',
          label: 'whitelabel',
          sortable: true
        },
        { key: 'config', label: 'config' },
        { key: 'actions', label: 'actions' }
      ];
    },
    totalRows() {
      return this.$store.state.wlConfig.rows?.count;
    }
  },

  methods: {
    raisePopup({ whitelabelId, whitelabelName, isActive, isEdit, target }) {
      this.$root.$emit('bv::show::modal', 'wlConfigModal', target);
      this.isEdit = isEdit;
      this.form.whitelabelId = isEdit ? whitelabelId : null;
      this.form.config = null;
      this.form.whitelabelName = isEdit ? whitelabelName : null;
      this.form.isActive = isActive;
    },
    download(config, whitelabelName) {
      const link = document.createElement('a');
      const blob = new Blob([JSON.stringify(config)], {
        type: 'application/json'
      });

      link.href = window.URL.createObjectURL(blob);
      link.download = `${whitelabelName}_config.json`;
      link.click();
    },
    deleteWlConfig(id) {
      if (confirm('Delete this item?')) {
        const promise = this.$store.dispatch('removeWlConfig', {
          id
        });
        promise.then(this.getWlConfig);
      }
    },
    changeIsActive(id) {
      const promise = this.$store.dispatch('changeWlConfigIsActive', {
        id
      });
      promise.then(this.getWlConfig).catch(this.getWlConfig);
    },
    wlConfigFormSubmit() {
      const formData = new FormData();
      formData.append('config', this.form.config);
      formData.append('whitelabelId', this.form.whitelabelId);
      formData.append('isActive', this.form.isActive);
      const promise = this.$store.dispatch(
        this.isEdit ? 'editWlConfig' : 'addWlConfig',
        formData
      );
      promise.then(this.getWlConfig);
    },
    getWlConfig() {
      const promise = this.$store.dispatch('getWlConfig');

      return promise.then(() => {
        return this.$store.state.wlConfig.rows || [];
      });
    }
  },
  created: function() {
    this.getWlConfig();
  },
  components: { VueJsonPretty }
};
</script>

<style scoped>
.localisation-table {
  margin-top: 2rem;
}

.edit-warning {
  display: inline-block;
  margin-bottom: 1rem;
  color: red;
}

.active-switch {
  display: inline-block;
  margin-left: 1rem;
}
</style>
